<template>
  <!-- 菜单权限管理 -->
  <div class="paddbox autobox">
    <div>
      <el-card>
        <div class="topss flex">
          <div>
            <el-form :inline="true">
              <el-form-item label="商品库名称">
                <el-input v-model="name" placeholder="可模糊" size="mini" clearable></el-input>
              </el-form-item>
              <el-form-item label="升级版组织ID">
                <el-input v-model="accountId" placeholder="精准" size="mini" clearable></el-input>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="librarylistFun" size="mini">查询</el-button>
              </el-form-item>
            </el-form>
          </div>
          <div>
            <el-button type="warning" @click="syncSPKFun()" size="mini">同步商品库</el-button>
          </div>
        </div>

        <!-- table部分 -->
        <div>
          <el-table :data="tableData" border style="width: 100%">
            <el-table-column prop="advertiserId" label="组织id" width="180"> </el-table-column>
            <el-table-column prop="advertiserName" label="组织名称" width="300"> </el-table-column>
            <el-table-column prop="platformId" label="商品库id" width="180"> </el-table-column>
            <el-table-column prop="name" label="商品库名称" width="260"> </el-table-column>
            <el-table-column label="(巨量数据管理员可看)" width="100" v-if="rId == 16">
              <template #default="scope">
                <el-button type="text" @click="openSPFun(scope.row)">查看商品</el-button>
              </template>
            </el-table-column>
            <el-table-column label="查看商品" width="100">
              <template #default="scope">
                <el-button type="text" @click="openSPRWFun(scope.row)">查看商品</el-button>
              </template>
            </el-table-column>
            <el-table-column prop="dbCreateTime" label="创建时间" width="180"> </el-table-column>
            <el-table-column prop="dbUpdateTime" label="修改时间" width="180"> </el-table-column>
            <el-table-column label="操作">
              <template #default="scope">
                <!-- <el-button type="primary" @click="packageEdit(scope)" icon="el-icon-edit" circle
                  size="mini"></el-button>
                <el-button type="danger" @click="packagedeleteFun2(scope)" icon="el-icon-delete" circle
                  size="mini"></el-button> -->
                <el-button type="success" plain @click="addSPviewBtnFun(scope.row)" size="mini">添加商品</el-button>
              </template>

            </el-table-column>

          </el-table>
        </div>
        <!-- 分页 -->
        <div class="pagination">
          <pagination @handleSizeChange="handleSizeChange" @handleCurrentChange="handleCurrentChange" :total="total"
            :pagesize="pagesize" :currentPage="currentPage"></pagination>
        </div>
      </el-card>
    </div>

    <div>
      <!-- 同步商品库弹窗控制 -->
      <el-dialog v-model="pullSPKView" width="70%">
        <el-container>
          <el-aside width="400px">
            <!-- 搜索框 -->
            <el-input placeholder="请输入组织名称" v-model="filterText" clearable></el-input>
            <!-- 树 -->
            <el-tree class="filter-tree" :data="treeData" :props="defaultProps" :filter-node-method="filterNode"
              @node-click="handleNodeClick" ref="treeRef">
              <template #default="{ node, data }">
                <span class="custom-tree-item">
                  <span class="level-tag">{{ node.level }}</span>
                  <span class="tree-label">{{ data.name }}</span>
                </span>
              </template>
            </el-tree>
          </el-aside>

          <el-main>
            <el-form label-width="180px">
              <el-form-item label="选中的组织:">
                <el-input v-model="syncAccountName" disabled="ture" clearable size="mini"></el-input>
              </el-form-item>
              <font color="red">
                不输入商品库名称或id，为全量同步，速度较慢; 输入商品库名称或id，为增量同步，速度较快</font>
              <el-form-item>

              </el-form-item>
              <el-form-item label="商品库名称/商品库id:">
                <el-input v-model="nameOrId" placeholder="商品库名称(模糊)/商品库id(精准)" clearable size="mini"></el-input>
              </el-form-item>

              <!-- 其他筛选项 -->
              <el-form-item>
                <el-button type="success" size="mini" @click="librarysyncFun()">{{ nameOrId == '' ? '全量同步' : '增量同步'
                }}</el-button>
                <!-- <el-button size="mini">重置</el-button> -->
              </el-form-item>
            </el-form>
          </el-main>
        </el-container>
      </el-dialog>


      <!-- 查看商品弹窗任务控制 -->
      <el-dialog title="查看商品任务" v-model="SPView" width="70%">
        <div>
          <el-form inline>
            <el-form-item label="商品">
              <el-input v-model="SPproductName" type="textarea" :rows="3" style="width: 300px"
                placeholder="商品(选填，可模糊，一行一个)" clearable size="mini"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" size="mini" @click="librarycreateTaskListFun()">查询</el-button>
            </el-form-item>
            <el-form-item>
              <el-button type='warning' size="mini" @click="openSyncProductFun()">同步商品</el-button>
            </el-form-item>
          </el-form>
        </div>
        <div>
          <el-table :data="librarycreateTaskData" border style="width: 100%">
            <!-- <el-table-column prop="createName" label="创建人" width="180"> </el-table-column> -->
            <!-- <el-table-column prop="accountId" label="组织id" width="180"> </el-table-column> -->
            <el-table-column prop="productName" label="商品名称"> </el-table-column>
            <el-table-column prop="playletId" label="专辑id"> </el-table-column>
            <el-table-column prop="productId" label="商品id"> </el-table-column>
            <!-- <el-table-column prop="status" label="状态" width="80" sortable>
              <template #default="scope">
                <span :class="[
                  scope.row.status === 3 ? 'text-red' :
                    scope.row.status === 2 ? 'text-green' :
                      scope.row.status === 1 ? 'text-orange' :
                        scope.row.status === 0 ? 'text-blue' : ''
                ]">
                  {{ scope.row.status === 3 ? '失败' : scope.row.status === 2 ? '已完成' :
                    scope.row.status === 1 ? '处理中' : scope.row.status === 0 ? '创建中' : '其他' }}
                </span>
              </template>
            </el-table-column> -->
            <!-- <el-table-column prop="createTime" label="创建时间" width="180"> </el-table-column> -->
            <el-table-column prop="updateTime" label="更新时间" width="180"> </el-table-column>
            <el-table-column prop="errorMsg" label="错误信息"> </el-table-column>
          </el-table>
        </div>
        <div>
          <!-- 分页 -->
          <div class="pagination">
            <pagination @handleSizeChange="handleSizeChange2" @handleCurrentChange="handleCurrentChange2"
              :total="total2" :pagesize="pagesize2" :currentPage="currentPage2"></pagination>
          </div>
        </div>
      </el-dialog>



      <!-- 巨量数据弹窗控制 -->
      <el-dialog title="巨量数据查看商品" v-model="SPlistView" width="60%">
        <div>
          <div class="Top_btn">
            <div>
              <el-form inline>
                <el-form-item label="商品">
                  <el-input v-model="SPproductName" placeholder="商品(选填，可模糊)" clearable size="mini"></el-input>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" size="mini" @click="libraryebpProductListFun()">查询</el-button>
                </el-form-item>
              </el-form>
            </div>
            <div>
              <el-button type='warning' size="mini" @click="libraryebpProductSyncFun()">同步商品</el-button>
            </div>
          </div>

        </div>
        <div>
          <el-table :data="libraryebpProductListData" border style="width: 100%">
            <el-table-column prop="name" label="剧名"> </el-table-column>
            <el-table-column prop="profession.playlet_id" label="专辑id" width="180"> </el-table-column>
            <el-table-column prop="product_id" label="商品id" width="180"> </el-table-column>
            <el-table-column prop="first_category" label="一级" width="100"> </el-table-column>
            <el-table-column prop="sub_category" label="二级" width="100"> </el-table-column>
            <el-table-column prop="third_category" label="三级" width="100"> </el-table-column>
            <!-- <el-table-column prop="createTime" label="创建时间" width="180"> </el-table-column>
            <el-table-column prop="updateTime" label="更新时间" width="180"> </el-table-column>
            <el-table-column prop="errorMsg" label="错误信息"> </el-table-column> -->
          </el-table>
        </div>
        <div>
          <!-- 分页 -->
          <div class="pagination">
            <pagination @handleSizeChange="handleSizeChange3" @handleCurrentChange="handleCurrentChange3"
              :total="total3" :pagesize="pagesize3" :currentPage="currentPage3"></pagination>
          </div>
        </div>
      </el-dialog>



      <!-- 添加商品弹窗控制 -->
      <el-dialog title="添加商品" v-model="addSPview" width="74%" destroy-on-close>
        <ylyProductCreate :spData="spData" @submit="submitProductCreate"></ylyProductCreate>
      </el-dialog>

      <!-- 同步商品弹窗控制（查看商品任务内） -->
      <el-dialog title="同步商品" v-model="syncProductView" width="40%" append-to-body>
        <el-form label-width="120px">
          <el-form-item label="商品名称:">
            <el-input v-model="syncProductName" placeholder="单个商品名称(选填，可模糊)，不填为根据数量同步商品" clearable
              size="mini"></el-input>
          </el-form-item>
          <el-form-item label="最大同步数量:">
            <el-input-number v-model="syncMaxCount" :min="1" :max="5000" size="mini"></el-input-number>
            <div style="color:#999;font-size:12px;margin-top:4px;">最大5000，默认500</div>
          </el-form-item>
        </el-form>
        <template #footer>
          <el-button size="mini" @click="syncProductView = false">取消</el-button>
          <el-button type="primary" size="mini" @click="confirmSyncProductFun()">确定</el-button>
        </template>
      </el-dialog>



    </div>
  </div>
</template>

<script>
import { librarylist, librarysync, teamAccounttree, teamshareteamTree, libraryproductCreate, librarycreateTaskList, libraryebpProductList, librarystrategySave, librarystrategyList, libraryebpProductSync } from '@/request/new/ylyBatch'
import { ElMessage } from 'element-plus'
import { inject, reactive, toRefs, watch, ref } from 'vue'
import pagination from '@/components/pagination.vue' // 导入分页组件
import ylyProductCreate from '@/components/ylyBatch/ylyProductCreate.vue' // 添加商品


export default {
  name: 'spgl',
  components: { pagination, ylyProductCreate },
  setup() {
    //模板ref，不能放进reactive
    const treeRef = ref(null)
    const state = reactive({
      // 商品库名称
      name: '',
      // 升级版组织ID
      accountId: '',
      tableData: [],
      // ==========树相关参数==========
      filterText: '',
      treeData: [],
      defaultProps: {
        children: 'children',
        label: 'name',
      },
      syncAccountName: '',
      syncAccountId: '',
      nameOrId: '',
      //添加商品的传入数据
      spData: {
        accountId: '',
        accountType: 'EBP',
        platformId: '',
        name: ''
      },
      librarycreateTaskData: [],
      libraryebpProductListData: [],
      //获取角色权限编号
      rId: localStorage.getItem('rId'),
      // 条数
      pagesize: 20,
      // 当前页数
      currentPage: 1,
      // 总数
      total: 100,
      // 页数 发生改变
      handleCurrentChange: (e) => {
        state.currentPage = e
        librarylistFun()
      },
      // 个数 发生改变
      handleSizeChange: (e) => {
        state.pagesize = e
        librarylistFun()
      },
      // 条数
      pagesize2: 50,
      // 当前页数
      currentPage2: 1,
      // 总数
      total2: 100,
      // 页数 发生改变
      handleCurrentChange2: (e) => {
        state.currentPage2 = e
        state.librarycreateTaskListFun()
      },
      // 个数 发生改变
      handleSizeChange2: (e) => {
        state.pagesize2 = e
        state.librarycreateTaskListFun()
      },
      // 条数
      pagesize3: 20,
      // 当前页数
      currentPage3: 1,
      // 总数
      total3: 100,
      // 页数 发生改变
      handleCurrentChange3: (e) => {
        state.currentPage3 = e
        // state.librarycreateTaskListFun()
      },
      // 个数 发生改变
      handleSizeChange3: (e) => {
        state.pagesize3 = e
        // state.librarycreateTaskListFun()
      },
      //商品库视图
      pullSPKView: false,
      syncSPKFun: () => {
        state.pullSPKView = !state.pullSPKView
      },
      //商品任务视图
      SPView: false,
      syncSPFun: () => {
        state.SPView = !state.SPView
      },
      //商品视图
      SPlistView: false,
      syncSPlistFun: () => {
        state.SPlistView = !state.SPlistView
      },

      // 选中的商品库
      SSPid: '',
      // 选中的组织iD
      SPaccountId: '',
      // 查询商品的搜索的商品名称
      SPproductName: '',
      // 添加商品view
      addSPview: false,
      addSPviewFun: () => {
        state.addSPview = !state.addSPview
      },
      //查看商品任务
      openSPRWFun: (row) => {
        state.syncSPFun()
        state.SSPid = row.platformId
        state.SPaccountId = row.advertiserId
        state.SPproductName = ''
        state.currentPage2 = 1
        state.librarycreateTaskListFun()
      },

      //查看商品
      openSPFun: (row) => {
        state.syncSPlistFun()
        state.SSPid = row.platformId
        state.SPaccountId = row.advertiserId
        state.libraryebpProductListFun()
      },
      // 新建商品任务分页查询（借鉴 ylySelectProducts.vue）
      librarycreateTaskListFun: () => {
        const productNames = (state.SPproductName || '')
          .split(/\n+/)
          .map((line) => line.trim().replace(/\s+/g, ''))
          .filter((line) => line)
        const datas = {
          currentPage: state.currentPage2,
          size: state.pagesize2,
          platformId: state.SSPid,
          accountId: state.SPaccountId || null,
          ...(productNames.length ? { productNames } : {}),
        }
        librarycreateTaskList(datas).then((res) => {
          state.librarycreateTaskData = res.data.data
          state.currentPage2 = res.data.currenPage
          state.total2 = res.data.totalSize
        })
      },
      // 商品查询
      libraryebpProductListFun: () => {
        const datas = {
          page: state.currentPage3,
          pageSize: state.pagesize3,
          productPlatformId: state.SSPid,
          accountId: state.SPaccountId,
          productName: state.SPproductName || null,
        }
        libraryebpProductList(datas).then((res) => {
          state.libraryebpProductListData = res.data.list
          state.currentPage3 = res.data.pageInfo.page
          state.total3 = res.data.pageInfo.totalNumber
        })
      },
      // 同步商品
      libraryebpProductSyncFun: () => {
        const datas = {
          productPlatformId: state.SSPid,
          accountId: state.SPaccountId,
        }
        libraryebpProductSync(datas).then((res) => {
          if (res.code == 200) {
            ElMessage.success(res.msg)
          } else {
            ElMessage.error(res.msg)
          }
        })
      },
      // 同步商品弹窗（查看商品任务内）
      syncProductView: false,
      syncProductName: '',
      syncMaxCount: 500,
      openSyncProductFun: () => {
        state.syncProductName = ''
        state.syncMaxCount = 500
        state.syncProductView = true
      },
      confirmSyncProductFun: () => {
        const maxSyncCount = Math.min(Number(state.syncMaxCount) || 500, 5000)
        const datas = {
          productPlatformId: state.SSPid,
          accountId: state.SPaccountId,
          productName: state.syncProductName || null,
          maxSyncCount,
        }
        libraryebpProductSync(datas).then((res) => {
          if (res.code == 200) {
            ElMessage.success(res.msg)
            state.syncProductView = false
          } else {
            ElMessage.error(res.msg)
          }
        })
      },
      // 添加商品按钮
      addSPviewBtnFun: (row) => {
        state.spData.accountId = row.advertiserId
        state.spData.platformId = row.platformId
        state.spData.name = row.name
        state.addSPviewFun()
      },

      //点击节点查询账户
      handleNodeClick: (data, node) => {
        state.syncAccountId = data.id
        state.syncAccountName = data.name
      },
      //同步组织商品库
      librarysyncFun: () => {
        if (state.syncAccountId != '') {
          const datas = {
            accountId: state.syncAccountId,
            nameOrId: state.nameOrId,
          }
          librarysync(datas).then((res) => {
            if (res.code == 200) {
              ElMessage.success(res.msg)
              state.syncAccountId = ''
              state.nameOrId = ''
              state.syncAccountName = ''
              state.syncSPKFun()
              librarylistFun()
            }
          })
        } else {
          ElMessage.error('请先选中左边的组织')
        }
      },
      // 接收创建商品组件的数据
      submitProductCreate: (data) => {
        console.log('接收创建商品组件的数据', data)
        state.addSPviewFun()

      }
    })


    //================ setup顶层函数（和你示例handleSelectionChange同一层级）================
    /**树过滤回调，放在setup顶层，不放入state */
    const filterNode = (value, data) => {
      if (!value) return true
      return data.name.indexOf(value) !== -1
    }

    const librarylistFun = () => {
      const datas = {
        currentPage: state.currentPage,
        size: state.pagesize,
        name: state.name || null,
        accountId: state.accountId || null,
      }
      librarylist(datas).then((res) => {
        state.currentPage = res.data.currenPage
        state.total = res.data.totalSize
        state.tableData = res.data.data
      })
    }

    librarylistFun()

    //查询树
    // const teamAccounttreeFun = () => {
    //   teamAccounttree({}).then((res) => {
    //     state.treeData = res.data
    //   })
    // }

    // teamAccounttreeFun()

    //查询树
    const teamshareteamTreeFun = () => {
      teamshareteamTree().then((res) => {
        state.treeData = res.data
      })
    }

    teamshareteamTreeFun()

    /**监听树搜索 */
    watch(
      () => state.filterText,
      (val) => {
        treeRef.value?.filter(val)
      }
    )

    return {
      // 结构赋值，暴露出去就不用 state.xx
      ...toRefs(state),
      treeRef,
      librarylistFun,
      filterNode,
      // teamAccounttreeFun,
      teamshareteamTreeFun
    }
  },
}
</script>

<style lang="scss" scoped>
.topss {
  justify-content: space-between;
}

.filter-tree {
  margin-top: 10px;
}

/* 状态文字颜色 */
.text-red {
  color: #f56c6c;
}

.text-green {
  color: #67c23a;
}

.text-orange {
  color: #e6a23c;
}

.text-blue {
  color: #409eff;
}

.custom-tree-item {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.level-tag {
  background-color: #e5e7eb;
  color: #666;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 12px;
}


.Top_btn {
  display: flex;
  justify-content: space-between;
}
</style>
